import {pxToRem} from '../../../utills/pxToRem'
import {fonts} from '../../foundations/fonts'
import colors from '../../foundations/colors'

export default {
    baseStyle: {
        stackContainer: {
            whiteSpace: 'nowrap',
            flexWrap: 'nowrap',
            justifyContent: 'center',
            alignItems: 'stretch',
            flex: 1,
            minHeight: 0,
            height: '100%',
            width: '100%',
            gap: [0, 0, pxToRem(10), pxToRem(10)],
            paddingRight: [pxToRem(0), pxToRem(0), 0, 0]
        },
        popoverContent: {
            position: 'fixed',
            left: 0,
            right: 0,
            width: '100%',
            maxWidth: '100%',
            backgroundColor: 'white',
            borderRadius: 0,
            border: 0,
            zIndex: 1500,
            boxShadow: 'none'
        },
        popoverBody: {
            padding: [
                pxToRem(24),
                pxToRem(24),
                `${pxToRem(40)} ${pxToRem(1)} ${pxToRem(40)} ${pxToRem(45)}`,
                `${pxToRem(40)} ${pxToRem(1)} ${pxToRem(40)} ${pxToRem(45)}`
            ],
            overflow: 'visible',
            '& a:focus-visible': {
                outline: `${pxToRem(2)} solid ${colors.cav_header_hover}`,
                outlineOffset: pxToRem(2),
                textDecoration: 'none'
            }
        },
        popoverBodyInner: {
            fontSize: '1rem',
            lineHeight: 1.2
        },
        popoverContainer: {
            paddingLeft: [pxToRem(20), pxToRem(20), pxToRem(8), pxToRem(8)],
            paddingRight: [pxToRem(10), pxToRem(10), pxToRem(8), pxToRem(8)],
            paddingTop: [pxToRem(10), pxToRem(10), 0, 0],
            paddingBottom: [0, 0, 0, 0]
        },
        listMenuTriggerContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            minHeight: '100%',
            flex: '0 0 auto',
            minWidth: 0,
            alignSelf: 'stretch',
            borderBottom: `${pxToRem(5)} solid transparent`,
            _hover: {
                borderBottomColor: 'white',
                backgroundColor: colors.cav_header_hover
            },
            _focusWithin: {
                borderBottomColor: 'white',
                backgroundColor: colors.cav_header_hover
            }
        },
        listMenuTriggerContainerActive: {
            borderBottom: `${pxToRem(5)} solid white`,
            backgroundColor: colors.cav_header_hover
        },
        listMenuTriggerLink: {
            fontFamily: fonts.primary,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            minHeight: '100%',
            width: '100%',
            flexGrow: 1,
            whiteSpace: 'nowrap',
            paddingTop: [0, 0, pxToRem(5), pxToRem(5)],
            paddingRight: [pxToRem(2), pxToRem(2), pxToRem(3), pxToRem(5)],
            paddingBottom: 0,
            paddingLeft: [pxToRem(2), pxToRem(2), pxToRem(3), pxToRem(5)],
            fontSize: [pxToRem(8), pxToRem(8), pxToRem(11), pxToRem(14)],
            fontWeight: '600',
            lineHeight: '100%',
            textTransform: 'uppercase',
            letterSpacing: [pxToRem(1), pxToRem(1), pxToRem(2), pxToRem(3)],
            color: 'white',
            outline: 'none',
            _hover: {
                textDecoration: 'none',
                color: 'white',
                borderBottomColor: 'white',
                backgroundColor: colors.cav_header_hover
            },
            _focus: {
                outline: `${pxToRem(2)} solid white`,
                outlineOffset: pxToRem(-2),
                textDecoration: 'none',
                color: 'white'
            },
            _focusVisible: {
                outline: `${pxToRem(2)} solid white`,
                outlineOffset: pxToRem(-2),
                textDecoration: 'none',
                color: 'white'
            }
        },
        listMenuTriggerLinkActive: {
            textDecoration: 'none'
        },
        listMenuTriggerlessLinkActive: {
            textDecoration: 'none'
        },
        listMenuTriggerLinkIcon: {
            marginTop: 3,
            marginRight: 3,
            marginBottom: 2,
            marginLeft: 0,
            _hover: {textDecoration: 'none'}
        },
        menuContainer: {
            flex: '1 1 auto',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            gap: pxToRem(40)
        },
        imageContainer: {
            flex: '0 0 auto',
            width: {md: '45%', xl: '42%'},
            maxWidth: {md: '45%', xl: '42%'},
            overflow: 'hidden',
            alignSelf: 'flex-start'
        }
    },
    parts: [
        'stackContainer',
        'popoverContent',
        'popoverBody',
        'popoverBodyInner',
        'popoverContainer',
        'listMenuTriggerContainer',
        'listMenuTriggerLink',
        'listMenuTriggerLinkActive',
        'listMenuTriggerIcon',
        'menuContainer',
        'imageContainer'
    ]
}
